import React from "react";
import { useLocation } from "react-router-dom";

import "./KYCConsent.css";
import { useEffect, useState } from "react";
import { getConsentForm, generateConsentOtp, submitConsentForm } from "../../../actions/creation/getConsentForm";
import { SelectFilter } from "../../dashboard/components/SelectFilter";
import { useCallback } from "react";

const KYCConsent = () => {
  const { search } = useLocation();

  function decodeBase64(str) {
    return Buffer.from(str, "base64").toString("utf8");
  }

  const url = search;
  const match = url.match(/\?([^/]+)/);
  const queryPart = url.split("?")[1];
  if (!queryPart) throw new Error("Invalid URL: missing '?'");
  const parts = queryPart.split("/");
  const firstPart = match ? match[1] : null;
  const secondPart = parts[1];
  const thirdPart = parts[2];

  const decodedPhoneNumber = secondPart ? decodeBase64(secondPart) : null;
  const decodedOutletId = thirdPart ? decodeBase64(thirdPart) : null;

  const [consentData, setConsentData] = useState([]);
  const [consentStatus, setConsentStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState();
  const [otpError, setOtpError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [missingKycPopup, setMissingKycPopup] = useState("");
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [rejectionReasons, setRejectionReasons] = useState([]);
  const [selectedRejectionReason, setSelectedRejectionReason] = useState("");
  const [rejectionReasonError, setRejectionReasonError] = useState("");
  const [customRejectionReason, setCustomRejectionReason] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");



  // Make fetchConsentForm reusable
  const fetchConsentForm = useCallback(async () => {
    try {
      const response = await getConsentForm(firstPart);
      setConsentData(response.result);
      if (response.result && response.result[0]) {
        setIfscCode(response.result[0].ifsc_code || "");
        setAccountNumber(response.result[0].account_number || "");
        // Get rejection reasons if present
        if (response.result[0].rejection_reason && Array.isArray(response.result[0].rejection_reason)) {
          setRejectionReasons(response.result[0].rejection_reason);
        } else if (response.result[0].rejection_reason && typeof response.result[0].rejection_reason === 'object') {
          // If it's an object (key-value), convert to array of {value, label}
          setRejectionReasons(Object.entries(response.result[0].rejection_reason).map(([value, label]) => ({ value, label })));
        }
        // const missing = getMissingFields(response.result[0]);
        // if (missing.length > 0) {
        //   setMissingKycPopup(
        //     `KYC form does not contain: ${missing
        //       .map((key) => formatLabel(key))
        //       .join(", ")}`
        //   );
        // } else {
        //   setMissingKycPopup(""); // reset if all good
        // }
      }
    } catch (error) {
      console.error("Error fetching retailer requests:", error);
    }
  }, []);

  // State for missing KYC data popup

  const formatLabel = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Helper: find missing fields dynamically
  const getMissingFields = (data) => {
    if (!data) return [];
    return Object.keys(data).filter(
      (key) => data[key] === null || data[key] === "" || data[key] === undefined
    );
  };

  useEffect(() => {
    fetchConsentForm();
  }, [fetchConsentForm]);

  const onAccept = useCallback(() => {
    setConsentStatus("accepted");
    setShowConfirm(true);
  }, []);

  const onRejectClick = useCallback(() => {
    setConsentStatus("rejected");
    setShowConfirm(true);
  }, []);

  const handleConfirm = async () => {
    setShowConfirm(false);
    // Get phone_number and outlet_id from consentData[0]
    const phone_number = decodedPhoneNumber;
    const outlet_id = consentData[0]?.id;
    if (!phone_number || !outlet_id) {
      alert("Missing phone number or outlet ID");
      return;
    }
    try {
      await generateConsentOtp(phone_number, accountNumber, ifscCode, outlet_id);
      setOtp(undefined);
      setOtpError("");
      setShowOtp(true);
    } catch (error) {
      setOtpError(error.message || "Failed to generate OTP. Please try again.");
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (!otp || otp.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");
    // If rejected, show rejection reason popup
    if (consentStatus === 'rejected') {
      setShowOtp(false);
      setShowRejectionReason(true);
      return;
    }
    // Prepare payload for submitConsentForm
    const phone_number = decodedPhoneNumber;
    const outlet_id = consentData[0]?.id;
    const dataPayload = { ...consentData[0] };
    delete dataPayload.rejection_reason;
    try {
      await submitConsentForm({ outlet_id, consent_status: consentStatus, phone_number, otp, decodedOutletId, data: dataPayload });
      setShowOtp(false);
      setOtp();
      setShowSuccess(true);
    } catch (error) {
      setOtpError(error.message || "Failed to submit OTP. Please try again.");
    }
  };

  // Handle rejection reason submit
  const handleRejectionReasonSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRejectionReason) {
      setRejectionReasonError("Please select a rejection reason.");
      return;
    }
    if ((selectedRejectionReason === 'other_reasons' || selectedRejectionReason === 'Other') && !customRejectionReason.trim()) {
      setRejectionReasonError("Please enter a reason for rejection.");
      return;
    }
    // Validate max 30 words
    if ((selectedRejectionReason === 'other_reasons' || selectedRejectionReason === 'Other') && customRejectionReason.trim().split(/\s+/).length > 30) {
      setRejectionReasonError("Reason cannot exceed 30 words.");
      return;
    }
    setRejectionReasonError("");
    const phone_number = decodedPhoneNumber;
    const outlet_id = consentData[0]?.id;
    let reasonToSend = selectedRejectionReason;
    if (selectedRejectionReason === 'other_reasons' || selectedRejectionReason === 'Other' || selectedRejectionReason === 'other') {
      // Prefix with 'other_reason - ' and snake_case the user input
      const snake = customRejectionReason
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '_')
        .replace(/^_+|_+$/g, '');
      reasonToSend = `other_reason - ${snake}`;
    }
    try {
      await submitConsentForm({ outlet_id, consent_status: consentStatus, phone_number, otp, decodedOutletId, rejection_reason: reasonToSend });
      setShowRejectionReason(false);
      setShowSuccess(true);
      setOtp();
      setSelectedRejectionReason("");
      setCustomRejectionReason("");
    } catch (error) {
      console.log("erorrrr", error);
      setRejectionReasonError(error.message || "Failed to submit rejection. Please try again.");
    }
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setOtp(undefined); // ✅ Clear previous OTP
    setOtpError("");

  };

  // State for required KYC fields (dynamic)
  // Fetch required KYC fields from API


  // If any required KYC field is missing, show popup and do not display form




  // If consent_status is accepted or rejected, show only a message
  const consentAccepted = consentData[0]?.consent_status === 'accepted';
  const consentRejected = consentData[0]?.consent_status === 'rejected';

  if (missingKycPopup) {
    return (
      <div className="popup-overlay">
        <div
          className="popup-content"
          style={{
            padding: "32px 16px",
            maxWidth: 350,
            minWidth: 280,
            margin: "0 auto",
          }}
        >
          <div
            className="popup-message"
            style={{ color: "#ff4d4f", fontWeight: 600, fontSize: 18 }}
          >
            {missingKycPopup}
          </div>
        </div>
      </div>
    );
  }

  if (consentAccepted || consentRejected) {
    return (
      <div className="pdf-background" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="popup-content" style={{ padding: '32px 16px', maxWidth: 350, minWidth: 280, margin: '0 auto' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
            {consentAccepted ? (
              <>
                <div className="success-tick-circle">
                  <svg width="64" height="64" viewBox="0 0 64 64">
                    <circle cx="32" cy="32" r="30" fill="#eafaf1" stroke="#2ecc71" strokeWidth="4" />
                    <polyline points="20,34 30,44 46,24" fill="none" stroke="#2ecc71" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="popup-message" style={{ color: '#2ecc71', fontWeight: 600, fontSize: 20 }}>
                  Consent form has been accepted successfully.
                </div>
              </>
            ) : (
              <>
                <div className="rejected-cross-circle">
                  <svg width="64" height="64" viewBox="0 0 64 64">
                    <circle cx="32" cy="32" r="30" fill="#faeaea" stroke="#ff4d4f" strokeWidth="4" />
                    <line x1="22" y1="22" x2="42" y2="42" stroke="#ff4d4f" strokeWidth="5" strokeLinecap="round" />
                    <line x1="42" y1="22" x2="22" y2="42" stroke="#ff4d4f" strokeWidth="5" strokeLinecap="round" />
                  </svg>
                </div>
                <div className="popup-message" style={{ color: '#ff4d4f', fontWeight: 600, fontSize: 20 }}>
                  Consent form has been rejected.
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="pdf-background"
      style={
        showConfirm || showOtp
          ? { position: "relative", overflow: "hidden" }
          : {}
      }
    >
      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ overflow: 'visible', maxWidth: '350px', minWidth: '280px', padding: '24px 16px' }}>
            <div className="popup-message">
              Are you sure you want to consent the form?
            </div>
            <div className="popup-actions">
              <button className="btn btn-cancel" onClick={handleCancel}>Cancel</button>
              <button className="btn btn-confirm" onClick={handleConfirm}
                style={{ background: '#2ecc71', color: '#fff' }}
              >Confirm</button>
            </div>
          </div>
        </div>
      )}
      {/* OTP Popup (reusing popup markup and buttons) */}
      {showOtp && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="popup-message">
              Enter OTP to confirm consent
            </div>
            <form onSubmit={handleOtpSubmit}>
              <input
                type="text"
                maxLength={6}
                value={otp}
                onChange={e => setOtp(e.target.value.replace(/[^0-9]/g, ''))}
                placeholder="------"
                inputMode="numeric"
                pattern="[0-9]*"
                autoFocus
              />
              {otpError && <div className="popup-error">{otpError}</div>}
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                <div className="popup-actions" style={{ display: 'flex', gap: '16px', width: 'auto' }}>
                  <button type="button" className="btn btn-cancel" onClick={() => setShowOtp(false)}>Cancel</button>
                  <button type="submit" className="btn btn-confirm"
                    style={{ background: '#2ecc71', color: '#fff' }}
                  >Submit OTP</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Rejection Reason Popup */}
      {showRejectionReason && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ padding: '32px 16px', maxWidth: 350, minWidth: 280 }}>
            <form onSubmit={handleRejectionReasonSubmit}>
              <div className="popup-message" style={{ marginBottom: 12 }}>
                Please select a reason for rejection:
              </div>
              <SelectFilter
                props={{
                  placeholder: " - - - Choose the type - - - ",
                  options: rejectionReasons.map(r => ({ value: r.value || r, label: r.label || r })),
                  value: rejectionReasons.find(r => (r.value || r) === selectedRejectionReason) || null,
                  onChange: (option) => {
                    setSelectedRejectionReason(option ? option.value : "");
                    setCustomRejectionReason("");
                  },
                  isClearable: true,
                }}
                containerStyles={{ width: '100%', marginBottom: 12 }}
              />
              {/* Show text field if 'Other' is selected */}
              {(selectedRejectionReason === 'other' || selectedRejectionReason === 'Other' || selectedRejectionReason === 'other_reasons' || selectedRejectionReason === 'Other Reasons') && (
                <textarea
                  className="popup-input"
                  placeholder="Type your reason (max 30 words)"
                  style={{ width: '100%', marginBottom: 12, padding: 8, minHeight: 60 }}
                  maxLength={30}
                  value={customRejectionReason}
                  onChange={e => setCustomRejectionReason(e.target.value)}
                />
              )}
              {rejectionReasonError && <div className="popup-error">{rejectionReasonError}</div>}
              <div className="popup-actions" style={{ display: 'flex', gap: '16px', width: 'auto', justifyContent: 'center' }}>
                <button type="button" className="btn btn-cancel" onClick={() => setShowRejectionReason(false)}>Cancel</button>
                <button type="submit" className="btn btn-confirm" style={{ background: '#ff4d4f', color: '#fff' }} onClick={handleRejectionReasonSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Success Popup */}
      {showSuccess && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ padding: '32px 16px', maxWidth: 350, minWidth: 280 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
              {consentStatus === 'rejected' ? (
                <>
                  <div className="rejected-cross-circle">
                    <svg width="64" height="64" viewBox="0 0 64 64">
                      <circle cx="32" cy="32" r="30" fill="#faeaea" stroke="#ff4d4f" strokeWidth="4" />
                      <line x1="22" y1="22" x2="42" y2="42" stroke="#ff4d4f" strokeWidth="5" strokeLinecap="round" />
                      <line x1="42" y1="22" x2="22" y2="42" stroke="#ff4d4f" strokeWidth="5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div className="popup-message" style={{ color: '#ff4d4f', fontWeight: 600 }}>
                    Consent has been rejected.
                  </div>
                  <button
                    className="btn btn-confirm"
                    style={{ background: '#ff4d4f', color: '#fff' }}
                    onClick={() => {
                      setShowSuccess(false);
                      fetchConsentForm();
                    }}
                  >
                    Close
                  </button>
                </>
              ) : (
                <>
                  <div className="success-tick-circle">
                    <svg width="64" height="64" viewBox="0 0 64 64">
                      <circle cx="32" cy="32" r="30" fill="#eafaf1" stroke="#2ecc71" strokeWidth="4" />
                      <polyline points="20,34 30,44 46,24" fill="none" stroke="#2ecc71" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className="popup-message" style={{ color: '#2ecc71', fontWeight: 600 }}>
                    Consent Successful!
                  </div>
                  <button
                    className="btn btn-confirm"
                    style={{ background: '#2ecc71', color: '#fff' }}
                    onClick={() => {
                      setShowSuccess(false);
                      fetchConsentForm();
                    }}
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <div
        className="pdf-document"
        role="document"
        aria-label="ˀˀent Declaration"
      >
        {/* Header */}
        <div className="pdf-header">
          <div className="pdf-header-text">
            <div className="pdf-title">KYC CONSENT DECLARATION</div>
            <div className="pdf-details">
              Level 2, A-wing, Suashish IT Park, 202, Off Dattapada Road,
              Borivali, Mumbai, Maharashtra 400066
            </div>
            <div className="pdf-details">+91-8657983878 | +91-9820929577</div>
            <div className="pdf-details">retailerhelpdesk@retail-scan.com</div>
          </div>

          <div className="pdf-header-logo">
            <img src="https://www.retail-scan.com/img/logo.png" alt="Company Logo" />
          </div>
        </div>
        <div className="pdf-field">
          <b style={{ fontSize: '18px' }}>Outlet Name:</b> <span style={{ fontSize: '18px' }}>{consentData[0]?.outlet_name}</span>
        </div>
        {/* KYC Table */}
        <table className="pdf-table" role="table" aria-label="KYC Details">
          <tbody>
            <tr>
              <td>
                <div className="section-label">KYC Details</div>
                <div className="pdf-field">
                  <b>Bank Account No:</b> {consentData[0]?.account_number}
                </div>
                <div className="pdf-field">
                  <b>Bank Name:</b> {consentData[0]?.bank}
                </div>
                <div className="pdf-field">
                  <b>IFSC Code:</b> {consentData[0]?.ifsc_code}
                </div>
                <div className="pdf-field">
                  <b>Account Type:</b> {consentData[0]?.account_type}
                </div>
                <div className="pdf-field">
                  <b>Account Holder Name:</b> {consentData[0]?.account_holder_name}
                </div>
                <div className="pdf-field">
                  <b>Outlet Owner:</b> {consentData[0]?.owner_name}
                </div>
              </td>
              <td>
                <div className="pdf-field">
                  <b>Address:</b> {consentData[0]?.address}
                </div>
                <div className="pdf-field">
                  <b>City:</b> {consentData[0]?.city}
                </div>
                <div className="pdf-field">
                  <b>PAN No:</b> {consentData[0]?.pan_number}
                </div>
                <div className="pdf-field">
                  <b>GST No:</b> {consentData[0]?.gst_number}
                </div>
                <div className="pdf-field">
                  <b>Mobile No:</b> {consentData[0]?.mobile_number}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Consent Text */}
        <div className="pdf-paragraph">
          I/We hereby provide consent to Retail Scan Management Services Private
          Limited to use my/our existing KYC records, including identity proofs,
          address proofs, and bank details already submitted and verified
          earlier, for the purpose of enabling payment transfers for{" "}
          <b>{consentData[0]?.organization}</b>, related communication, and
          compliance requirements.
        </div>
        <div className="pdf-paragraph">
          I/We confirm that the information provided in my/our KYC documents is
          true, correct, and up to date. I/We further authorize Retail Scan
          Management Services Private Limited to share, validate, or verify
          these details with relevant authorities, financial institutions, or
          service providers, as may be required under applicable laws and
          regulations.
        </div>
        <div className="pdf-paragraph">
          This consent shall remain valid unless and until revoked by me/us in
          writing.
        </div>

        {/* Signature */}
        <div className="pdf-signature">
          <b>Retailer Signature and Stamp:</b>
          <br />
          <br />
          __________________________
        </div>
      </div>
      {/* Sticky footer: centered, looks like PDF viewer controls */}
      <div
        className="sticky-footer"
        role="region"
        aria-label="Document Actions"
      >
        <div className="footer-inner">
          <button
            className="btn btn-accept"
            onClick={onAccept}
            aria-label="Accept document"
          >
            Accept
          </button>
          <button
            className="btn btn-reject"
            onClick={onRejectClick}
            aria-label="Reject document"
          >
            Reject
          </button>

        </div>
      </div>
    </div>
  );
};

export default KYCConsent;